import React from 'react';
import { useDispatch } from 'react-redux';
import {updateOrderItem} from "../../../../store/slices/orderSlice";

const ProductQuantityAction = ({ product, index }) => {
    const dispatch = useDispatch();

    const updateQty = (e, i, action) => {
        e.preventDefault();
        let newQuantity = product.quantity;

        if (action === 'increment') {
            newQuantity += 1;
        } else if (action === 'decrement' && product.quantity > 0) {
            newQuantity -= 1;
        } else if (action === 'input') {
            newQuantity = parseInt(e.target.value, 10) || 0;
        }

        dispatch(updateOrderItem({ quantity: newQuantity, index: i }));
    };

    return (
        <div className="min-add-button">
            <div className="input-group">
                <button className="input-group-addon minus increment" onClick={(e) => updateQty(e, index, 'decrement')}>
                    <i className="lni lni-minus" />
                </button>
                <input
                    type="text"
                    className="form-control"
                    id="adults"
                    value={product.quantity}
                    onChange={(e) => updateQty(e, index, 'input')}
                />
                <button className="input-group-addon minus increment" onClick={(e) => updateQty(e, index, 'increment')}>
                    <i className="lni lni-plus" />
                </button>
            </div>
        </div>
    );
};

export default ProductQuantityAction;
